import { FiMenu } from "react-icons/fi";

const DashboardHeader = ({ greeting, subtitle, badge, onMenuClick }) => (
  <header className="dashboard-header">
    <div className="dashboard-header__left">
      <button type="button" className="dashboard-header__menu" onClick={onMenuClick} aria-label="Open menu">
        <FiMenu />
      </button>
      <div>
        <p className="dashboard-header__greeting">
          {greeting}
          {subtitle && <span> — {subtitle}</span>}
        </p>
      </div>
    </div>
    {badge && (
      <span className={`dashboard-header__badge ${badge.verified ? "verified" : ""}`}>
        {badge.text}
      </span>
    )}
  </header>
);

export default DashboardHeader;
